/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2023-11-15 13:22:25
 * @FilePath: \frontend\src\store\getters.js
 */
const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  user_name: (state) => state.user.user_name,
  user_id: (state) => state.user.user_id,
  token: (state) => state.user.token,
  userConfig: (state) => state.user.userConfig,
  mode: (state) => state.user.mode,
  tenantId: (state) => state.user.tenantId,
  gwName: (state) => state.system.gwName,
  time: (state) => state.system.time,
  isShowNotification: (state) => state.system.isShowNotification,
  lang: (state) => state.system.lang,
  isInit: (state) => state.system.isInit,
  gatewaysArea: (state) => state.router.gatewaysArea,
  gatewaysGW: (state) => state.router.gatewaysGW,
  gatewaysAddDevice: (state) => state.router.gatewaysAddDevice,
  devicesArea: (state) => state.router.devicesArea,
  devicesGW: (state) => state.router.devicesGW,
  mapArea: (state) => state.router.mapArea,
  mapGW: (state) => state.router.mapGW,
  pubsubDisconnected: (state) => state.app.pubsub.disconnected,
  pubsubReloading: (state) => state.app.pubsub.reloading,
  viewport: (state) => state.app.viewport,
  occupyingGW: (state) => state.app.occupyingGW,
  serviceList: (state) => state.service.serviceList,
  basicServiceId: (state) => state.service.basicServiceId,
};
export default getters;
